module.exports = __webpack_public_path__ + "img/internal-documents_1.5a9eea92.svg";